module.exports = __webpack_public_path__ + "img/pemkot.959ee7d8.jpeg";